export const checkoutEN = {
  less255: "Maximum 255 characters",
  less50: "Maximum 50 characters",
  less20: "Maximum 20 characters",
  less10: "Maximum 10 characters",
  required: "Required",
  invalidEmail: "Invalid email",
  invalidPhone: "Invalid number",
  textareaMax: "Maximum 1000 characters",
  invalidPayment: "Invalid payment method",
  terms: "You must accept the terms and conditions",
  createAccount : "Create Account" ,
  differentDeliveryAddress : "Deliver to a different address",
  orderComments : "Order Comments",
  payment : "PAYMENT" ,
  cash : "Pay on delivery",
  cashInShop : "Pay in store",
  cashText : "Pay cash when items are delivered",
  clickAway : "Collection",
  clickAwayText : "Collect items from the shop",
  paypalRadio : "Credit card or PayPal",
  vivaRadio : "Credit card or Viva",
  creditCard : "Credit card",
  paypalError : "Please fill in the form correctly !",
  personalDataInfo : "Your personal data will be used for the needs of this site and for the handling of your account.",
  readThe : "Read the" ,
  iHaveRead : "I have read and agree with the" ,
  ofThisSite : "of this site" ,
  yourOrder : "Your Order",
  sendOrder : "Send Order",
  alreadyCustomer : "I am already a customer",
  orderCompleteTitle: "ORDER COMPLETED!",
  orderCompleteLine1: "Your order has been successfully received.",
  orderCompleteLine2: "Thank you for your order.",
  isCompany: "Issue Invoice",
  companyAfm: "VAT number",
  companyDoy: "Tax Office",
  companyName: "Company Name",
  companyProfession: "Profession",
  bankTransfer: "Direct Bank Transfer",
  bankTransferText: "Transfer to one of our bank accounts.",
  bankLargeText: "Make your payment directly to our bank account. Please include your order ID in your bank transfer. Your order will be shipped after your money transfer has been verified.",
  bank: "Bank",
  nbgRadio: "Credit card through NBG Bank",
  without: "Without",
  checkoutData: "Payment",
  product: "PRODUCT",
  subTotal: "SUB-TOTAL",
  without: "WITHOUT",
  total: "TOTAL",
  doYouHave: "Already have an account? Click ",
  here: "here",
  toConnect: " to connect.",
  legalName: "Legal Name",
  legalDescription: "Company type",
  postalAddress: "Main street",
  postalAddressNo: "Number",
  postalAreaDescription: "Main town",
  postalZipCode: "Postcode",
  firmActDescription: "Main occupation",
  companyPhone: "Phone",
  companyEmail: "Email",
  doyDescription: "Tax office name",
  returnToShop: "BACK TO STORE",
  alergies:" Do you have an allergy or intolerance to any food? Any nutritional specificity? Contact the store before placing your order.",
  proceedToPayment: "PROCEED TO PAYMENT",
  allowRecurring: "Recurring payment",
  subscriptionInterval: "Interval between payments in months",
  delivery: "Delivery",
  orderKind: "How to receive",
  scheduleForLater: "Schedule for later",
  scheduledDeliveryTime: "Schedule delivery time",
  scheduledPickupTime: "Schedule collection time",
  alreadyOnTable: "Already on this table",
  notChargedToYou: "Already ordered - not added to your payment.",
  paidLabel: "Paid",
  partiallyPaidLabel: "Part. paid",
  unpaidLabel: "Unpaid",
  fillAllFields: "Please fill in all required fields.",
  invalidTotal: "Invalid order total. Please review your cart.",
  paymentError: "Payment failed. Please try again.",
  invalidVat: "Invalid VAT number",
  pickupNoAddress: "Collection from the shop — no delivery address needed.",
}